
  <table class="table table-sm" *ngIf="tableData$ | async as tableData">
    <thead>
      <tr>
        <th sortable="description" (sort)="onSort($event)" scope="col">{{'Description' | translate}}</th>
        <th
          sortable="valmetDnaValue.numericValue"
          (sort)="onSort($event)"
          scope="col">
          {{'Value' | translate}}
        </th>
        <th scope="col">{{'Unit' | translate}}</th>
        <th scope="col">{{'Timestamp' | translate}}</th>
      </tr>
    </thead>
    <tbody style="overflow-y: visible">

        <ng-container *ngFor="let row of tableData.rows">
          <ng-container *ngIf="row.valmetDnaMetadata?.tagsResult; else tagNotFoundBlock">
            <tr [class]="valueIsZero(row.valmetDnaValue) ? 'inactive': ''">
              <td [ngbTooltip]="row.valmetDnaMetadata.tag.TagName">
                {{ row.valmetDnaMetadata.tag.Description }}
              </td>
              <td [class]="!row.formattedValue ? 'text-warning': ''">
                {{ row.formattedValue ? row.formattedValue : '-' }}
              </td>
              <td>
                {{ row.valmetDnaMetadata.tag.Unit }}
              </td>
              <ng-container *ngIf="row.valmetDnaValue?.ts; else timestampNotFound">
                <td [ngbTooltip]="row.valmetDnaValue.ts">
                  {{ timestampAgeInMinutes(row.valmetDnaValue.ts) }} min
                </td>
              </ng-container>
              <ng-template #timestampNotFound>
                <td></td>
              </ng-template>
            </tr>
          </ng-container>

          <ng-template #tagNotFoundBlock>
            <tr>
              <td [ngbTooltip]="row.valmetDnaMetadata?.requestedTag.fullTag">
                {{ 'Tag was not found' | translate }}
              </td>
              <td>
                -
              </td>
              <td>
                -
              </td>
              <td>
                -
              </td>
            </tr>
          </ng-template>

        </ng-container>

        <ng-container *ngIf="tableData.totalValueSum">
          <tr>
            <td>
              {{ 'Total' | translate }}
            </td>
            <td>
              ~ {{ tableData.totalValueSum }}
            </td>
            <td></td>
            <td></td>
          </tr>
        </ng-container>

    </tbody>
  </table>
  <ng-container *qmLoading="loading;config:loadingConfig"></ng-container>
